import React from "react";
import { ISendingMessageProps } from "./~types/SendingMessageProps";

import  "./SendingMessage.css";
import Paper  from "@material-ui/core/Paper"; //use mui in dotnet 6
import { Spinner } from "reactstrap";

const SendingMessage = (props: ISendingMessageProps) => {

    const style = props.sendingMessage.failed ? " send-message-failed" : " sending-message-in-proccess";

    return (
        <div className="client_message">
            <Paper className={"message__content " + style}>
                {props.sendingMessage.message.text}
                {props.sendingMessage.failed ? 
                    <span className="sending-message-resend"><button onClick={() => props.onResendClick(props.sendingMessage.message)}>⟳</button></span> : 
                    <span className="sending-message-spinner"><Spinner style={{ width: '1rem', height: '1rem' }} /></span>
                 }
            </Paper>
        </div>
    );
}

export default SendingMessage;